export default __webpack_public_path__ + "static/media/sopSaveIcon.75d6b588.svg";